import 'css-chunksrc/client/scenes/projectListingConfiguration/form/columns/form/styles.scss';export default {
  "input": "_input_gpexq_1",
  "listRoot": "_listRoot_gpexq_14",
  "list": "_list_gpexq_14",
  "item": "_item_gpexq_30",
  "icon": "_icon_gpexq_43",
  "timeSheetIcon": "_timeSheetIcon_gpexq_51",
  "name": "_name_gpexq_56"
};